import { render } from "./CreateDistrict.vue?vue&type=template&id=103117e1&scoped=true"
import script from "./CreateDistrict.vue?vue&type=script&lang=js"
export * from "./CreateDistrict.vue?vue&type=script&lang=js"

import "./CreateDistrict.vue?vue&type=style&index=0&id=103117e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103117e1"]])

export default __exports__